import { createContext, useContext, useState } from "react";

// ── CONTEXT ───────────────────────────────────────────────────────────────────

export const LangContext = createContext({ lang: "en", t: (_, fallback) => fallback });

export function useLang() {
  return useContext(LangContext);
}

// ── TEXTOS EN INGLÉS ──────────────────────────────────────────────────────────

const TEXTS_EN = {
  navTagline: "Exclusive deals, music proyects, executive production & worldwide alliances.",
  navGroup: "GROUP",
  navRecords: "RECORDS",
  heroLabel: "Projects in México",
  heroPrev: "Previous",
  heroNext: "Next",
  sectionArtists: "Artists & Live Bookings",
  requestAvailability: "REQUEST AVAILABILITY",
  sectionCreative: "Creative",
  campaignBreak: "Campaigns & Design",
  doeLabel: "Doe Boy - Epic Records",
  inquireNow: "INQUIRE NOW",
  sectionPartners: "Partners",
  partnersBreak: "& Sponsors",
  aeroLabel: "Aeroart 2023 & 2024 - México City",
  artistsWorkedWith: "Artists we've worked with",
  viewAll: "VIEW ALL",
  dssEyebrow: "[ InterPlay E. Group Partnering with ]",
  dssTitle: "Maestros Joyeros",
  dssSub: "Side by Side with Artists",
  dssBody1: "We have brought exclusive artists to Maestros Joyeros locations, including Young Miko, Polimá Westcoast, Kevin Roldán, and more.",
  dssBody2: "A collaboration between companies born from the relationship between the CEOs of both brands, creating unique experiences such as the Circus Maximus Tour experience with Travis Scott.",
  drop1Label: "Dei V, Cover Design by InterPlay E. Group",
  drop2Label: "Millaray, Cover Design by InterPlay E. Group",
  groupWorkWith: "Work With Us",
  groupSub: "Luxury brands, artists, and more",
  groupBody1: "We work with select world class companies, operating from Mexico across more than seven countries since 2018, we choose to work exclusively with the best, providing a wide range of services primarily focused on the music industry.",
  groupBody2: "Today, we are the home where projects for your favorite artists and premium brands come to life.",
  recordsTitle: "Label Division",
  recordsSub: "Bring Your Project to Life With Us",
  recordsBody: "Discover our catalog of worldwide Gold and Platinum producers, collaboration management, songwriting services, professional pre-release consulting, and collaborations with artists from our record division.",
  footerGroup: "InterPlay Entertainment Group",
  footerMain: "InterPlay Entertainment",
  footerRecords: "InterPlay Entertainment Records",
  footerCopy: "InterPlay Entertainment - © All rights reserved.",
  modalTitle: "NEW MESSAGE",
  modalTo: "To:",
  modalSubject: "Subject",
  modalMessage: "Message",
  modalSend: "SEND",
  "CIRCUS MAXIMUS TOUR": "CIRCUS MAXIMUS TOUR",
  "OFFICIAL AFTERPARTY": "OFFICIAL AFTERPARTY",
  "FULL SHOW PAPANTLA": "FULL SHOW PAPANTLA",
  "SPECIAL GUEST FESTIVAL VV": "SPECIAL GUEST FESTIVAL VV",
  "SPECIAL GUEST": "SPECIAL GUEST",
  "FULL SHOW FESTIVAL VV": "FULL SHOW FESTIVAL VV",
  "Lettering Design": "Lettering Design",
  "Cover + Lettering Design": "Cover + Lettering Design",
  "COVER + EXCLUSIVE DESIGN": "COVER + EXCLUSIVE DESIGN",
  "Cover Design": "Cover Design",
  "Vinyl Shop": "Vinyl Shop",
  Artists: "Artists",
  Music: "Music",
  Vinyl: "Vinyl",
  '7" Vinyl': '7" Vinyl',
  CDs: "CDs",
  Cassettes: "Cassettes",
  "Box Sets": "Box Sets",
  "Test Pressings": "Test Pressings",
  "Signed Music": "Signed Music",
  Soundtracks: "Soundtracks",
  Merch: "Merch",
  Tops: "Tops",
  Sweatshirts: "Sweatshirts",
  Outerwear: "Outerwear",
  Headwear: "Headwear",
  Accessories: "Accessories",
  Posters: "Posters",
  Exclusives: "Exclusives",
  Collections: "Collections",
  "New Arrivals": "New Arrivals",
  "GRAMMY® Nominees": "GRAMMY® Nominees",
  "Definitive Sound Series": "Definitive Sound Series",
  "2Pac x LA Kings": "2Pac x LA Kings",
  "Homecoming Szn": "Homecoming Szn",
  Vintage: "Vintage",
  "Gallery Vinyl": "Gallery Vinyl",
  "Staff Picks": "Staff Picks",
  "Vinyl Collective": "Vinyl Collective",
  "Subscribe Now": "Subscribe Now",
  Archive: "Archive",
  "Reserves Store": "Reserves Store",
  FAQ: "FAQ",
  "Lost Highway": "Lost Highway",
};

// ── TEXTOS EN ESPAÑOL ─────────────────────────────────────────────────────────

const TEXTS_ES = {
  navTagline: "Deals exclusivos, proyectos musicales, producción ejecutiva y alianzas mundiales.",
  navGroup: "GRUPO",
  navRecords: "DISQUERA",
  heroLabel: "Proyectos en México",
  heroPrev: "Anterior",
  heroNext: "Siguiente",
  sectionArtists: "Artistas & Bookings en Vivo",
  requestAvailability: "SOLICITAR DISPONIBILIDAD",
  sectionCreative: "Creatividad",
  campaignBreak: "Campañas & Diseño",
  doeLabel: "Doe Boy - Epic Records",
  inquireNow: "COTIZAR AHORA",
  sectionPartners: "Socios",
  partnersBreak: "& Patrocinadores",
  aeroLabel: "Aeroart 2023 & 2024 - Ciudad de México",
  artistsWorkedWith: "Artistas con los que hemos trabajado",
  viewAll: "VER TODOS",
  dssEyebrow: "[ InterPlay E. Group en alianza con ]",
  dssTitle: "Maestros Joyeros",
  dssSub: "Lado a Lado con Artistas",
  dssBody1: "Hemos llevado artistas exclusivos a las ubicaciones de Maestros Joyeros, incluyendo a Young Miko, Polimá Westcoast, Kevin Roldán, y más.",
  dssBody2: "Una colaboración entre empresas nacida de la relación entre los CEOs de ambas marcas, creando experiencias únicas como la experiencia del Circus Maximus Tour con Travis Scott.",
  drop1Label: "Dei V, Diseño de Portada por InterPlay E. Group",
  drop2Label: "Millaray, Diseño de Portada por InterPlay E. Group",
  groupWorkWith: "Trabaja Con Nosotros",
  groupSub: "Marcas de lujo, artistas y más",
  groupBody1: "Trabajamos con empresas de clase mundial seleccionadas, operando desde México en más de siete países desde 2018. Elegimos trabajar exclusivamente con los mejores, ofreciendo una amplia gama de servicios enfocados principalmente en la industria musical.",
  groupBody2: "Hoy somos el hogar donde cobran vida los proyectos de tus artistas favoritos y las marcas premium.",
  recordsTitle: "División de Sello",
  recordsSub: "Dale Vida a Tu Proyecto Con Nosotros",
  recordsBody: "Descubre nuestro catálogo de productores mundiales de Oro y Platino, gestión de colaboraciones, servicios de composición, consultoría profesional pre-lanzamiento y colaboraciones con artistas de nuestra división discográfica.",
  footerGroup: "InterPlay Entertainment Group",
  footerMain: "InterPlay Entertainment",
  footerRecords: "InterPlay Entertainment Records",
  footerCopy: "InterPlay Entertainment - © Todos los derechos reservados.",
  modalTitle: "NUEVO MENSAJE",
  modalTo: "Para:",
  modalSubject: "Asunto",
  modalMessage: "Mensaje",
  modalSend: "ENVIAR",
  "CIRCUS MAXIMUS TOUR": "CIRCUS MAXIMUS TOUR",
  "OFFICIAL AFTERPARTY": "AFTERPARTY OFICIAL",
  "FULL SHOW PAPANTLA": "SHOW COMPLETO PAPANTLA",
  "SPECIAL GUEST FESTIVAL VV": "INVITADO ESPECIAL FESTIVAL VV",
  "SPECIAL GUEST": "INVITADO ESPECIAL",
  "FULL SHOW FESTIVAL VV": "SHOW COMPLETO FESTIVAL VV",
  "Lettering Design": "Diseño de Lettering",
  "Cover + Lettering Design": "Diseño de Portada + Lettering",
  "COVER + EXCLUSIVE DESIGN": "PORTADA + DISEÑO EXCLUSIVO",
  "Cover Design": "Diseño de Portada",
  "Vinyl Shop": "Tienda de Vinilos",
  Artists: "Artistas",
  Music: "Música",
  Vinyl: "Vinyl",
  '7" Vinyl': '7" Vinyl',
  CDs: "CDs",
  Cassettes: "Cassettes",
  "Box Sets": "Box Sets",
  "Test Pressings": "Test Pressings",
  "Signed Music": "Música Firmada",
  Soundtracks: "Soundtracks",
  Merch: "Merch",
  Tops: "Camisetas",
  Sweatshirts: "Sudaderas",
  Outerwear: "Ropa de Abrigo",
  Headwear: "Gorras",
  Accessories: "Accesorios",
  Posters: "Posters",
  Exclusives: "Exclusivos",
  Collections: "Colecciones",
  "New Arrivals": "Nuevos Lanzamientos",
  "GRAMMY® Nominees": "Nominados al GRAMMY®",
  "Definitive Sound Series": "Definitive Sound Series",
  "2Pac x LA Kings": "2Pac x LA Kings",
  "Homecoming Szn": "Homecoming Szn",
  Vintage: "Vintage",
  "Gallery Vinyl": "Gallery Vinyl",
  "Staff Picks": "Selección del Staff",
  "Vinyl Collective": "Vinyl Collective",
  "Subscribe Now": "Suscríbete Ahora",
  Archive: "Archivo",
  "Reserves Store": "Tienda de Reservas",
  FAQ: "FAQ",
  "Lost Highway": "Lost Highway",
};

// ── LANG TOGGLE BUTTON ────────────────────────────────────────────────────────

export function LangToggle({ lang, onToggle }) {
  return (
    <button
      onClick={onToggle}
      title={lang === "en" ? "Traducir al español" : "Switch to English"}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        background: "none",
        border: "1px solid currentColor",
        borderRadius: "4px",
        padding: "4px 10px",
        cursor: "pointer",
        fontFamily: "Space Mono, monospace",
        fontSize: "11px",
        letterSpacing: "0.08em",
        fontWeight: 600,
        color: "inherit",
        whiteSpace: "nowrap",
      }}
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
      {lang === "en" ? "ES" : "EN"}
    </button>
  );
}

// ── PROVIDER ──────────────────────────────────────────────────────────────────

export function TranslationProvider({ children }) {
  const [lang, setLang] = useState("en");

  const t = (key, fallback) => {
    const texts = lang === "en" ? TEXTS_EN : TEXTS_ES;
    return texts[key] !== undefined
      ? texts[key]
      : fallback !== undefined
      ? fallback
      : key;
  };

  const handleToggleLang = () => {
    setLang((prev) => (prev === "en" ? "es" : "en"));
  };

  return (
    <LangContext.Provider value={{ lang, t }}>
      <LangToggleContext.Provider value={{ lang, loading: false, onToggle: handleToggleLang }}>
        {children}
      </LangToggleContext.Provider>
    </LangContext.Provider>
  );
}

// ── CONTEXTO SECUNDARIO ───────────────────────────────────────────────────────

export const LangToggleContext = createContext({
  lang: "en",
  loading: false,
  onToggle: () => {},
});

export function useLangToggle() {
  return useContext(LangToggleContext);
}